const HIGHEST_WEEKS = 'highestNumberOfWeeks';
const HIGHEST_CONSECUTIVE_WEEKS = 'highestNumberOfConsecutiveWeeks';
const HIGHEST_DAYS = 'highestNumberOfDays';
const HIGHEST_CONSECUTIVE_DAYS = 'highestNumberOfConsecutiveDays';

export const RequestPriorityRuleOption = Object.freeze({
    [HIGHEST_WEEKS]: 0,
    [HIGHEST_CONSECUTIVE_WEEKS]: 1,
    [HIGHEST_DAYS]: 2,
    [HIGHEST_CONSECUTIVE_DAYS]: 3,
});

export const RequestPriorityRuleOptionNames = Object.freeze({
    0: HIGHEST_WEEKS,
    1: HIGHEST_CONSECUTIVE_WEEKS,
    2: HIGHEST_DAYS,
    3: HIGHEST_CONSECUTIVE_DAYS
});

